export const MODAL_TITLE = 'What is OMV?';
